export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || '/api';

export const API_SPEC_DOCUMENTATION_API_URL = `${BASE_API_URL}/spec`;
export const AUTH_API_URL = `${BASE_API_URL}/auth`;
export const BOX_API_URL = `${BASE_API_URL}/box`;
export const CLIENTS_API_URL = `${BASE_API_URL}/client`;
export const COMMENTS_API_URL = `${BASE_API_URL}/comment`;
export const COUNTERPARTY_ESM = `${BASE_API_URL}/esm`;
export const COUNTERPARTY_REQUEST = `${BASE_API_URL}/counterparty-request`;
export const COUNTERPARTY_REQUEST_CATEGORIES = `${COUNTERPARTY_REQUEST}/categories`;
export const DOCUMENT_API_URL = `${BASE_API_URL}/document`;
export const ECP_API_URL = `${BASE_API_URL}/ecp`;
export const ENTITIES_API_URL = `${BASE_API_URL}/client`; // TODO remove in favor of clients
export const EXCHANGES_API_URL = `${CLIENTS_API_URL}/venues`;
export const FORM_API_URL = `${BASE_API_URL}/form`;
export const INVESTMENT_COMMITTEE_API_URL = `${BASE_API_URL}/investment-committee`;
export const LEI_DUPLICATE_ENTRY = `${BASE_API_URL}/client/validate`;
export const LOOKUP_API_URL = `${ECP_API_URL}/lookup`;
export const ONBOARDING_URL = `${BASE_API_URL}/client`;
export const PAGE_API_URL = `${BASE_API_URL}/navigation`;
export const RISK_COMMITTEE_API_URL = `${BASE_API_URL}/risk-committee`;
export const RISK_METRICS_API_URL = `${BASE_API_URL}/risk-metrics`;
export const OTC_API_URL = `${BASE_API_URL}/otc`;
export const ATM_API_URL = `${BASE_API_URL}/atm`;
export const UPLOAD_API_URL = `${BASE_API_URL}/user/upload`;
export const UPLOAD_FILE_API_URL = `${BASE_API_URL}/user/uploadFile`;
export const USER_API_URL = `${BASE_API_URL}/user`;
export const USER_LOGOUT_URL = `${BASE_API_URL}/auth/logout`;
export const WALLET_API_URL = `${BASE_API_URL}/wallet`;
export const TOKEN_MANAGEMENT_URL = `${BASE_API_URL}/api-management`;
export const ACTIVITY_LOG_URL = `${BASE_API_URL}/activity-log`;
export const LEGAL_ENTITIES = `${BASE_API_URL}/legal-entity`;
export const COMMITTEE_MANAGEMENT = `${BASE_API_URL}/committee-management`;
export const KYC_PERIODIC_REVIEWS = `${BASE_API_URL}/kyc-periodic-review`;
export const OPERATIONS_TEAMS = `${BASE_API_URL}/client/operations`;
// GLEIF
export const GLEIF_API_URL = 'https://api.gleif.org/api/v1/lei-records';
